import { render } from "./annual-account-graph.vue?vue&type=template&id=45250fa8"
import script from "./annual-account-graph.vue?vue&type=script&lang=js"
export * from "./annual-account-graph.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/my.fastfinance.app/my.fastfinance.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__